/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель для персональных рекомендаций.
   */
  app.PersonalRecommendations = app.Model.extend({
    additionalOptions: ['requestParameters', 'isLocoItems'],
    urlRoot: app.entryScriptName + '/api/v3/recommendation',
    expand: 'expand=cart_item',

    /**
     * Переопределяем urlRoot и GET-параметры для loco-товаров.
     * @inheritDoc
     */
    run: function () {
      if (this.isLocoItems) {
        this.urlRoot = app.entryScriptName + '/api/v3/item';
        this.requestParameters = {
          'main_category_id': this.requestParameters.category_id,
          'per-page': 20,
          expand: 'cart_item',
        };
      }
      this.defaultRequestParameters = this.requestParameters;
    },

    /**
     * Восстанавливает параметры запроса к дефолтным.
     */
    restoreDefaultRequestParameters: function () {
      this.requestParameters = this.defaultRequestParameters;
    },
  });
})();

}.call(window));